import { GLTFScenegraph } from "../api/gltf-scenegraph.js";
import { getPrimitiveTextureData } from "./utils/3d-tiles-utils.js";
const EXT_MESH_FEATURES_NAME = 'EXT_mesh_features';
export const name = EXT_MESH_FEATURES_NAME;
export async function decode(gltfData, options) {
    const scenegraph = new GLTFScenegraph(gltfData);
    decodeExtMeshFeatures(scenegraph, options);
}
/**
 * Decodes feature metadata from extension.
 * @param {GLTFScenegraph} scenegraph - Instance of the class for structured access to GLTF data.
 * @param {GLTFLoaderOptions} options - GLTFLoader options.
 */
function decodeExtMeshFeatures(scenegraph, options) {
    const json = scenegraph.gltf.json;
    if (!json.meshes) {
        return;
    }
    // Iterate through all meshes/primitives.
    for (const mesh of json.meshes) {
        for (const primitive of mesh.primitives) {
            processMeshPrimitiveFeatures(scenegraph, primitive, options);
        }
    }
}
/**
 * Takes data from EXT_mesh_features and store it in 'data' property of featureIds.
 * If combined with EXT_structural_metadata, corresponding data are taken from the property tables of that extension.
 * @param {GLTFScenegraph} scenegraph - Instance of the class for structured access to GLTF data.
 * @param {GLTFMeshPrimitive} primitive - Primitive that contains extensions.
 * @param {GLTFLoaderOptions} options - GLTFLoader options.
 */
function processMeshPrimitiveFeatures(scenegraph, primitive, options) {
    // Processing of mesh primitive features requires buffers to be loaded.
    if (!options?.gltf?.loadBuffers) {
        return;
    }
    const extension = primitive.extensions?.[EXT_MESH_FEATURES_NAME];
    const featureIds = extension?.featureIds;
    if (!featureIds) {
        return;
    }
    for (const featureId of featureIds) {
        let featureIdData;
        // Process "Feature ID by Vertex"
        if (typeof featureId.attribute !== 'undefined') {
            const accessorKey = `_FEATURE_ID_${featureId.attribute}`;
            const accessorIndex = primitive.attributes[accessorKey];
            featureIdData = scenegraph.getTypedArrayForAccessor(accessorIndex);
        }
        // Process "Feature ID by Texture Coordinates"
        else if (typeof featureId.texture !== 'undefined' && options?.gltf?.loadImages) {
            featureIdData = getPrimitiveTextureData(scenegraph, featureId.texture, primitive);
        }
        // Process "Feature ID by Index"
        else {
            /*
            When both featureId.attribute and featureId.texture are undefined,
            then the feature ID value for each vertex is given implicitly, via the index of the vertex.
            In this case, the featureCount must match the number of vertices of the mesh primitive.
            */
            // TODO: At the moment of writing we don't have a tileset with the data of that kind. Implement it later.
            featureIdData = [];
        }
        featureId.data = featureIdData;
    }
}
